import {isMollieEnabled} from "./featureFlags";

// A coupon's discount can depend on the payment method, so the checkout price preview needs to
// know which provider the payment will actually go through - mirroring the checkout pages' dispatch.
const COUPON_PAYMENT_METHODS = {
    creditcard : "credit_card",
    sepa       : "direct_debit",
    paypal     : "paypal",
};

export const getCouponPaymentMethod = (selectedPaymentMethod) => {
    if (selectedPaymentMethod === "paybybank") {
        // The API rejects Stripe Pay by Bank as a coupon payment method, so that path sends none.
        return isMollieEnabled() ? "mollie_pay_by_bank" : null;
    }

    return COUPON_PAYMENT_METHODS[selectedPaymentMethod] ?? null;
};
